
import { getCookie } from 'cookies-next';
import { company } from '@constants/company';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getFilteredProperties2 = async (filters, email = null, localeValue = 'en') => {
    let currencyValue = getCookie('currency')
    // let localeValue = getCookie('NEXT_LOCALE')
    // console.log(currencyValue)

    let { name, saleType, bts, project, category, categories, room, rooms, minBedrooms, maxBedrooms, page, currency, minprice, maxprice, petfriendly, seaview, beachfront, map, sort, district, districts, area, location, foreignquota } = filters
  
    if (name && name.toLowerCase().startsWith(company.refStarter)) saleType = ''

    const url = `${baseUrl}/properties?name=${name}&saleType=${saleType}&bts=${bts}&location=${location}&district=${district}&districts=${districts}&area=${area}&project=${project}&foreignquota=${foreignquota}&category=${category}&categories=${categories}&minprice=${minprice}&maxprice=${maxprice}&room=${room}&rooms=${rooms}&petfriendly=${petfriendly}&seaview=${seaview}&beachfront=${beachfront}&map=${map}&limit=8&page=${page}&sort=${sort}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'email': email,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        cache: 'no-store'
    })

    const result = await response.json()
    // console.log(result)

    const id = getCookie('id')
    const likes = getCookie('likes')
    if (id == undefined && likes !== undefined && likes.length > 0 && result.properties.length > 0) {
        // console.log('has likes')
        result.properties.forEach(property => {
            if (likes.includes(property.id)) {
                property.isLiked = true
            }
        })
    }

    // console.log(result)

    return result

}